export default __webpack_public_path__ + "static/media/scrollbutton.fb594651.svg";